import RequirementsMetPolicy from './RequirementsMetPolicy';
import QualityMentoringFormQuestion from './models/QualityMentoringFormQuestion';

const SHOW_QUESTION = true;
const HIDE_QUESTION = false;

export default class QuestionDisplayPolicy {
  private submission: any;

  private branch: any;

  private question: any;

  private startingQuestion: any;

  setSubmission(submission): QuestionDisplayPolicy {
    this.submission = submission.data;
    return this;
  }

  setBranch(branch): QuestionDisplayPolicy {
    this.branch = branch;
    return this;
  }

  setStartingQuestion(startingQuestion): QuestionDisplayPolicy {
    this.startingQuestion = startingQuestion;
    return this;
  }

  setQuestion(question: QualityMentoringFormQuestion): QuestionDisplayPolicy {
    this.question = question;
    return this;
  }

  apply() {
    if (!QuestionDisplayPolicy.questionIsOnExistingBranch(this.branch, this.submission)) {
      return HIDE_QUESTION;
    }

    if (QuestionDisplayPolicy.questionIsBeingDisplayedFirst(this.startingQuestion, this.question.id)) {
      return SHOW_QUESTION;
    }

    if (!QuestionDisplayPolicy.questionHasRequirements(this.question.requires)) {
      return SHOW_QUESTION;
    }

    if (RequirementsMetPolicy.questionHasMetRequirements(this.question.requires, this.branch, this.submission)) {
      return SHOW_QUESTION;
    }

    return HIDE_QUESTION;
  }

  isAnswerable(): boolean {
    if (!QuestionDisplayPolicy.questionHasRequirements(this.question.requires)) {
      return true;
    }

    if (RequirementsMetPolicy.questionHasFailedToMeetRequirements(this.question.requires, this.submission)) {
      return false;
    }

    return true;
  }

  private static questionHasRequirements(requires): boolean {
    return !!requires;
  }

  private static questionIsBeingDisplayedFirst(startingQuestion, questionId): boolean {
    return startingQuestion == questionId;
  }

  private static questionIsOnExistingBranch(branch: string, submission: any): boolean {
    if (!submission[branch]) {
      if (branch != 'root') {
        return false;
      }
      submission[branch] = {};
    }
    return true;
  }
}
